import dynamic from "next/dynamic";
import { oneOf } from "prop-types";

import AccountLoginPageTemplate from "~templates/AccountLoginPageTemplate";
import AccountSettingsPageTemplate from "~templates/AccountSettingsPageTemplate";

// ********************************
// Templates and fetchers.
// ********************************
// only import the templates when they are needed
const ArticleTemplate = dynamic(() => import("~templates/ArticleTemplate"));
const EventTemplate = dynamic(() => import("~templates/EventTemplate"));
const ExpertDetailTemplate = dynamic(() => import("~templates/ExpertDetail"));
const ExpertOverviewTemplate = dynamic(
  () => import("~templates/ExpertOverview"),
);
const FilterPageTemplate = dynamic(
  () => import("~templates/FilterPageTemplate"),
);
const ListicleTemplate = dynamic(() => import("~templates/ListicleTemplate"));
const LocationTemplate = dynamic(() => import("~templates/LocationTemplate"));
const OverviewTemplate = dynamic(() => import("~templates/OverviewTemplate"));
const JobSearchPageTemplate = dynamic(
  () => import("~templates/JobSearchPageTemplate"),
);
const AccountPageTemplate = dynamic(
  () => import("~templates/AccountPageTemplate"),
);

const DynamicPage = (props) => {
  switch (props.type) {
    case "Directory":
    case "OverviewPage":
      return <OverviewTemplate {...props} />;
    case "Article":
    case "NewsArticle":
      return <ArticleTemplate {...props} />;
    case "Listicle":
      return <ListicleTemplate {...props} />;
    case "FilterPage":
    case "CategoryGroup":
    case "Category":
      return <FilterPageTemplate {...props} />;
    case "Event":
      return <EventTemplate {...props} />;
    case "Location":
      return <LocationTemplate {...props} />;
    case "ExpertOverview":
      return <ExpertOverviewTemplate {...props} />;
    case "ExpertDetail":
      return <ExpertDetailTemplate {...props} />;
    case "JobSearchPage":
      return <JobSearchPageTemplate {...props} />;
    case "AccountPage":
      return <AccountPageTemplate {...props} />;
    case "AccountLoginPage":
      return <AccountLoginPageTemplate {...props} />;
    case "AccountSettingsPage":
      return <AccountSettingsPageTemplate {...props} />;
    default:
      console.error(`Template not found for type: ${props.type}`);
      return null;
  }
};

DynamicPage.propTypes = {
  type: oneOf([
    "Directory",
    "OverviewPage",
    "Article",
    "NewsArticle",
    "Listicle",
    "FilterPage",
    "CategoryGroup",
    "Category",
    "Event",
    "Location",
    "ExpertOverview",
    "ExpertDetail",
    "JobSearchPage",
    "AccountPage",
    "AccountLoginPage",
    "AccountSettingsPage",
  ]),
};

export default DynamicPage;
